import React, { useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { detectLivefeedV2 } from '../utils'
import TopMenuContainer from './TopMenuContainer';
import EditorContainer from './EditorContainer'
import { useDispatch } from 'react-redux'
import { mergeSlidesData } from 'actions/livefeed';
import Modal from "components/common/modal";

const Editor = (props) => {
    const dispatch = useDispatch();
    const { mode, passedData, key } = props.location.state || { mode: "createLivefeed", passedData: null }
    const fallbackModal = useRef(null)
    const handlePassingData = useCallback(() => {
        if (passedData !== undefined && passedData !== null) {
            dispatch(mergeSlidesData(passedData))
        }
    }, [dispatch, passedData])

    useEffect(() => {
        handlePassingData()
    }, [handlePassingData])

    // The livefeed version 1 doesn't contain slideType key on livefeedSlide object
    let isLivefeedV2 = passedData ? detectLivefeedV2(passedData.livefeedSlides) : true // if no passedData means creating new livefeed mode

    useEffect(() => {
        if (!isLivefeedV2) {
            fallbackModal.current.open()
        }
    }, [isLivefeedV2])

    return (
        <div className="template-editor-page overwrite--modal--depth">
            <TopMenuContainer
                editorMode={mode}
                editorKey={key}
                router={props.router}
            />
            <div className="page-content page-content_template-editor_padding">
                {isLivefeedV2 ?
                    <div className="editor-box bg--white box--shadow">
                        <EditorContainer
                            editorMode={mode}
                        />
                    </div>
                    :
                    <Modal
                        disableCloseButton={true}
                        ref={fallbackModal}
                        onClose={() => props.router.push({ pathname: '/livefeed' })}
                        clickButton={() => fallbackModal.current.close()}
                        header="Incompatible version"
                        buttonText="Got it"
                        buttonClass="btn-success"
                        entry={null}
                    >
                        <p style={{ textAlign: "left" }}>
                            This livefeed/template is incompatible with our recent update, please contact <a href="mailto:support@steerpath.com?subject=Livefeed Error">support@steerpath.com</a> or create a new livefeed/template again
                        </p>
                    </Modal>
                }
            </div>
        </div >
    );
}

Editor.propTypes = {
    router: PropTypes.object.isRequired
}

export default Editor;





// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/index.jsx